import request from '@/utils/request'

//购买证录入

//列表查询
export function getgmzMes(data) {
  return request({
    method: 'post',
    url: '/yzdservice/api/enterprise/gmz/lrList',
    data: data
  })
}
//购买证录入
export function gmzRecord(data) {
  return request({
    url: '/yzdservice/api/enterprise/gmz/record',
    method: 'post',
    data: data
  })
}
